import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { MobileThumbProps } from '../types';
import MobileThumbContent from '../_partials/MobileThumbContent';
import TopInfoBar from '../_partials/TopInfoBar';
import BottomInfoBar from '../_partials/BottomInfoBar';

import s from './Default.scss';

const TOP_EXTRA_HEIGHT = parseInt(s['topExtrasHeight'], 10);
const BOTTOM_EXTRA_HEIGHT = parseInt(s['bottomExtrasHeight'], 10);
const MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS = 50; // this one is pulled from behind
export const EXTRAS_HEIGHT = TOP_EXTRA_HEIGHT + BOTTOM_EXTRA_HEIGHT;

const DefaultMobileThumb: React.FC<MobileThumbProps> = ({
  className,
  deviation,
  height,
  responsive,
  style,
  width,
  extraActions,
}) => {
  const hasEnoughHeightForExtras =
    !!height && height > EXTRAS_HEIGHT + MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS;

  return (
    <Section
      className={classnames(
        s['root'],
        hasEnoughHeightForExtras && s['with-extras'],
        className
      )}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <ErrorBoundary debugComponent="DefaultMobileThumb">
        {hasEnoughHeightForExtras ? (
          <>
            <TopInfoBar
              deviation={deviation}
              extraActions={extraActions}
              className={s['top-extras']}
            />
            <MobileThumbContent
              deviation={deviation}
              width={width}
              height={height - EXTRAS_HEIGHT}
              responsive={responsive}
            />
            <BottomInfoBar
              deviation={deviation}
              className={s['bottom-extras']}
            />
          </>
        ) : (
          <MobileThumbContent
            deviation={deviation}
            width={width}
            height={height}
            responsive={responsive}
          />
        )}
      </ErrorBoundary>
    </Section>
  );
};
DefaultMobileThumb.displayName = 'DefaultMobileThumb';

export default DefaultMobileThumb;
